var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "osResHeader padTop txtC padBX" }, [
      _c("div", [
        _c("img", {
          staticStyle: {
            "max-width": "159px",
            "min-width": "80px",
            width: "23.6%"
          },
          attrs: {
            src:
              "https://www.amway.co.kr/_ui/_noticeImg/2023/03/0329_ev_a7070xgli/logo_glister.png",
            alt: "Artistry Skin Nutrition (로고)"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "fntH5 marTX", staticStyle: { color: "#3872d3" } },
        [
          _vm._v("\n    A7070 X 글리스터와 함께하는 "),
          _c("br", { staticClass: "moOnly" }),
          _vm._v("빈틈없는 구강관리의 완성\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass: "fntH1 fntM marTX",
          staticStyle: { color: "#2c2c2c", "line-height": "1.17" }
        },
        [
          _vm._v("\n    NEW 글리스터 "),
          _c("br"),
          _c("b", { staticStyle: { color: "#3872d3" } }, [
            _vm._v("구강건강 챌린지")
          ]),
          _c("br", { staticClass: "moOnly" }),
          _vm._v("\n    이벤트\n  ")
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "fntH6 marTML", staticStyle: { color: "#2c2c2c" } },
        [
          _vm._v("\n    신제품도 미리 체험하고, 새로워진 글리스터가 "),
          _c("br", { staticClass: "moOnly" }),
          _vm._v("준비한\n    선물도 받아보세요!\n  ")
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-794b11ad", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-794b11ad","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/nutrilite/a7070-glister/component/header.vue
// module id = null
// module chunks = 